var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41 -380) translate(30 168)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0 20 20 0 20z",
    transform: "translate(11 212)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M10 1.765c-3.252 0-5.882 2.577-5.882 5.764C4.118 11.853 10 18.235 10 18.235s5.882-6.382 5.882-10.706c0-3.187-2.63-5.764-5.882-5.764zm0 7.823c-1.16 0-2.1-.922-2.1-2.059 0-1.136.94-2.058 2.1-2.058 1.16 0 2.1.922 2.1 2.058 0 1.137-.94 2.06-2.1 2.06z",
    transform: "translate(11 212)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.22561f25956bfafffb110d61ade36550.svg";
export { ForwardRef as ReactComponent };